(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pk-guardian-menu-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pk-guardian-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.pathname !== location.pathname || url.search !== location.search) return;
    const drawer = link.closest('header-drawer');
    if (drawer) {
      drawer.closeMenuDrawer(event, drawer.mainDetailsToggle.querySelector('summary'));
      drawer.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
    } else {
      const menu = link.closest('header-menu');
      if (menu) menu.close();
      else {
        const details = link.closest('details');
        details?.removeAttribute('open');
        details?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
